<script setup lang="ts">
import { GemXInlineStack } from '../GemXInlineStack';

const props = defineProps<{
  variant?: 'A' | 'B';
  label?: string;
  tone?: 'origin' | 'variant';
  tooltip?: string;
  disabled?: boolean;
  hiddenLabel?: boolean;
}>();
const tone = computed(() => props?.tone ?? 'variant');
</script>

<template>
  <GemXInlineStack gap="200" block-align="center" :wrap="false">
    <slot name="prefix" />
    <div
      :class="[
        'flex h-6 w-6 min-w-6 items-center justify-center rounded-full',
        {
          'bg-gemx-origin': tone === 'origin',
          'bg-gemx-variant': tone === 'variant',
          'opacity-50': disabled,
        },
      ]">
      <p class="text-sm font-bold leading-5 text-white">
        {{ props?.variant }}
      </p>
    </div>
    <GemXInlineStack v-if="props?.label" gap="0">
      <h3 class="text-text-dark-500 line-clamp-1 text-xs font-semibold leading-5">
        {{ props?.label }}
      </h3>
    </GemXInlineStack>
    <slot name="suffix" />
  </GemXInlineStack>
</template>
